import api from './api'

export const userService = {
  getUsers: (filters: any) => api.get('/users', { params: filters }),
  getUserById: (id: number) => api.get(`/users/${id}`),
  createUser: (data: any) => api.post('/users', data),
  updateUser: (id: number, data: any) => api.put(`/users/${id}`, data),
  deleteUser: (id: number) => api.delete(`/users/${id}`),
  activateUser: (id: number) => api.put(`/users/${id}/activate`),
  deactivateUser: (id: number) => api.put(`/users/${id}/deactivate`),
}

export default userService


